module.exports = __webpack_public_path__ + "static/media/hand.ac0b92df.png";